import { ThemeColor } from '@idp/ui-components/components/panels/Feedback/FeedbackProps';
var MainViewState = /** @class */ (function () {
    function MainViewState() {
        this.error = { message: '', title: '', apiName: '', errorCode: '' };
        this.lastPanelTheme = ThemeColor.LIGHT;
        this.loading = true;
        this.reRenderOnPersonlization = false;
        this.allowCMSGetCall = false;
        this.prepaidFlow = false;
        this.canLoadLobConsole = true;
        this.dataToOrchestrateLogin = {
            data: {
                intent: 'sales-wireless',
                topPanel: false,
            },
            displayLogin: false,
        };
    }
    return MainViewState;
}());
export default MainViewState;
//# sourceMappingURL=MainView.container.state.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/core/components/MainView/MainView.container.state.js
// module id = 1418
// module chunks = 8